<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="city"
      @keyup="search"
      @change="handleSelect"
      :items="cities"
      :multiple="multiple"
      :label="$t('city.label.city')"
      :no-data-text="$t('city.noData')"
      prepend-inner-icon="mdi-magnify"
      item-value="id"
      item-text="name"
      outlined
    >
      <template v-slot:selection="{ item }">
        {{ selection(item) }}
      </template>
      <template v-slot:item="{ item }">
        {{ selection(item) }}
      </template>
    </v-autocomplete>

    <v-progress-circular
      v-show="isCitiesLoading"
      class="autocomplete-loading"
      color="primary"
      width="2"
      size="15"
      indeterminate
    />
  </div>
</template>

<script>
import { fetchCitiesPaginated } from '@/services/city/cityService'

export default {
  name: 'HCitySelect',

  props: {
    country: {
      type: String,
      default: 'BR',
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    defaultValue: {
      default: null,
    },
  },

  watch: {
    defaultValue(value) {
      if (!value) return

      this.cities = [value]
      this.$nextTick(() => this.city = value)
    },
  },

  methods: {
    selection(item) {
      if (!item) return

      const name = item?.name
      const acronym = item?.state?.acronym
      return `${name} ${acronym ? '/ ' + acronym : ''}`
    },

    handleSelect(value) {
      if (this.multiple) {
        this.selectedCities.push(value)
        this.$emit('input', this.selectedCities)
        return
      }

      this.$emit('input', value)
    },

    search({ target }) {
      const term = target?.value
      if (!term && term?.length <= 3) return

      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.isCitiesLoading = true

        fetchCitiesPaginated({ search: term, countryCode: this.country })
          .then(({ data }) => this.cities = data?.result)
          .catch(({ data }) => this.$store.dispatch('showErrorMessage', data.message))
          .finally(() => this.isCitiesLoading = false)
      }, 1000)
    },
  },

  data() {
    return {
      city: null,
      cities: [],
      selectedCities: [],
      isCitiesLoading: false,
      timer: null,
    }
  }
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-loading {
  position: absolute;
  top: 28px;
  right: 45px;
  transform: translateY(-50%);
}
</style>
